import company from '../store/modules/company'

function push(name, nickName, params, keys) {
    company.mutations.addPage(company.state, {
        nickName: nickName,
        name: name,
        params: params,
        keys: keys
    });
}

export default {
    push
}


// WEBPACK FOOTER //
// ./src/utils/myRouter.js